var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-layout",
                {
                  staticClass: "pt-1 pb-2",
                  attrs: {
                    row: "",
                    wrap: "",
                    "align-center": "",
                    "justify-space-around": "",
                    "fill-height": ""
                  }
                },
                [
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c("span", { staticClass: "blue--text font-weight-bold" }, [
                      _vm._v(
                        "DEPENDIENTES: " + _vm._s(_vm.l_dependientes.length)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c("span", { staticClass: "blue--text font-weight-bold" }, [
                      _vm._v(
                        "JEFE: " + _vm._s(_vm.l_jefe.length > 0 ? "SI" : "NO")
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c("span", { staticClass: "blue--text font-weight-bold" }, [
                      _vm._v("TOTAL PERSONAL: " + _vm._s(_vm.l_personas.length))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  staticClass: "mb-2",
                  attrs: {
                    row: "",
                    wrap: "",
                    "justify-center": "",
                    "align-center": ""
                  }
                },
                _vm._l(_vm.l_jefe, function(persona) {
                  return _c(
                    "v-flex",
                    {
                      key: persona.id_persona,
                      attrs: { xs12: "", sm4: "", md3: "" }
                    },
                    [
                      _c("ItemSliderComponent", {
                        key: persona.id_persona,
                        staticClass: "contenedor-jefe",
                        attrs: {
                          persona: persona,
                          campos_personales: _vm.campos_personales
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    wrap: "",
                    "align-space-around": "",
                    "justify-center": "",
                    "fill-height": ""
                  }
                },
                _vm._l(_vm.l_dependientes, function(persona) {
                  return _c(
                    "v-flex",
                    {
                      key: persona.id_persona,
                      attrs: { xs12: "", sm4: "", md3: "" }
                    },
                    [
                      _c("ItemSliderComponent", {
                        key: persona.id_persona,
                        attrs: {
                          persona: persona,
                          id: "content-card",
                          campos_personales: _vm.campos_personales
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-474a10a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-474a10a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/components/EstructuraUnidad.vue
// module id = null
// module chunks = 